import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { get, post, patch } from '../../util/api';

// ================ Action types ================ //

const FETCH_MY_COMPANY_REQUEST = 'app/AccountWelfarePage/FETCH_MY_COMPANY_REQUEST';
const FETCH_MY_COMPANY_SUCCESS = 'app/AccountWelfarePage/FETCH_MY_COMPANY_SUCCESS';
const FETCH_MY_COMPANY_ERROR = 'app/AccountWelfarePage/FETCH_MY_COMPANY_ERROR';

const FETCH_STATS_REQUEST = 'app/AccountWelfarePage/FETCH_STATS_REQUEST';
const FETCH_STATS_SUCCESS = 'app/AccountWelfarePage/FETCH_STATS_SUCCESS';
const FETCH_STATS_ERROR = 'app/AccountWelfarePage/FETCH_STATS_ERROR';

const FETCH_VOUCHERS_REQUEST = 'app/AccountWelfarePage/FETCH_VOUCHERS_REQUEST';
const FETCH_VOUCHERS_SUCCESS = 'app/AccountWelfarePage/FETCH_VOUCHERS_SUCCESS';
const FETCH_VOUCHERS_ERROR = 'app/AccountWelfarePage/FETCH_VOUCHERS_ERROR';

const FETCH_USAGE_REQUEST = 'app/AccountWelfarePage/FETCH_USAGE_REQUEST';
const FETCH_USAGE_SUCCESS = 'app/AccountWelfarePage/FETCH_USAGE_SUCCESS';
const FETCH_USAGE_ERROR = 'app/AccountWelfarePage/FETCH_USAGE_ERROR';

const DISTRIBUTE_REQUEST = 'app/AccountWelfarePage/DISTRIBUTE_REQUEST';
const DISTRIBUTE_SUCCESS = 'app/AccountWelfarePage/DISTRIBUTE_SUCCESS';
const DISTRIBUTE_ERROR = 'app/AccountWelfarePage/DISTRIBUTE_ERROR';
const DISTRIBUTE_RESET = 'app/AccountWelfarePage/DISTRIBUTE_RESET';

const FETCH_EMPLOYEES_REQUEST = 'app/AccountWelfarePage/FETCH_EMPLOYEES_REQUEST';
const FETCH_EMPLOYEES_SUCCESS = 'app/AccountWelfarePage/FETCH_EMPLOYEES_SUCCESS';
const FETCH_EMPLOYEES_ERROR = 'app/AccountWelfarePage/FETCH_EMPLOYEES_ERROR';

const FETCH_VOUCHER_POOLS_REQUEST = 'app/AccountWelfarePage/FETCH_VOUCHER_POOLS_REQUEST';
const FETCH_VOUCHER_POOLS_SUCCESS = 'app/AccountWelfarePage/FETCH_VOUCHER_POOLS_SUCCESS';
const FETCH_VOUCHER_POOLS_ERROR = 'app/AccountWelfarePage/FETCH_VOUCHER_POOLS_ERROR';

const UPDATE_SETTINGS_REQUEST = 'app/AccountWelfarePage/UPDATE_SETTINGS_REQUEST';
const UPDATE_SETTINGS_SUCCESS = 'app/AccountWelfarePage/UPDATE_SETTINGS_SUCCESS';
const UPDATE_SETTINGS_ERROR = 'app/AccountWelfarePage/UPDATE_SETTINGS_ERROR';

// ================ Reducer ================ //

const initialState = {
  company: null,
  stats: null,
  vouchers: [],
  usage: null,
  fetchCompanyInProgress: false,
  fetchCompanyError: null,
  fetchStatsInProgress: false,
  fetchStatsError: null,
  fetchVouchersInProgress: false,
  fetchVouchersError: null,
  fetchUsageInProgress: false,
  fetchUsageError: null,
  distributeInProgress: false,
  distributeError: null,
  distributeResult: null,
  employees: [],
  fetchEmployeesInProgress: false,
  fetchEmployeesError: null,
  voucherPools: [],
  fetchVoucherPoolsInProgress: false,
  fetchVoucherPoolsError: null,
  updateSettingsInProgress: false,
  updateSettingsError: null,
  updateSettingsResult: null,
};

export default function accountWelfarePageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_MY_COMPANY_REQUEST:
      return { ...state, fetchCompanyInProgress: true, fetchCompanyError: null };
    case FETCH_MY_COMPANY_SUCCESS:
      return { ...state, fetchCompanyInProgress: false, company: payload };
    case FETCH_MY_COMPANY_ERROR:
      return { ...state, fetchCompanyInProgress: false, fetchCompanyError: payload };

    case FETCH_STATS_REQUEST:
      return { ...state, fetchStatsInProgress: true, fetchStatsError: null };
    case FETCH_STATS_SUCCESS:
      return { ...state, fetchStatsInProgress: false, stats: payload };
    case FETCH_STATS_ERROR:
      return { ...state, fetchStatsInProgress: false, fetchStatsError: payload };

    case FETCH_VOUCHERS_REQUEST:
      return { ...state, fetchVouchersInProgress: true, fetchVouchersError: null };
    case FETCH_VOUCHERS_SUCCESS:
      return { ...state, fetchVouchersInProgress: false, vouchers: payload };
    case FETCH_VOUCHERS_ERROR:
      return { ...state, fetchVouchersInProgress: false, fetchVouchersError: payload };

    case FETCH_USAGE_REQUEST:
      return { ...state, fetchUsageInProgress: true, fetchUsageError: null };
    case FETCH_USAGE_SUCCESS:
      return { ...state, fetchUsageInProgress: false, usage: payload };
    case FETCH_USAGE_ERROR:
      return { ...state, fetchUsageInProgress: false, fetchUsageError: payload };

    case DISTRIBUTE_REQUEST:
      return { ...state, distributeInProgress: true, distributeError: null, distributeResult: null };
    case DISTRIBUTE_SUCCESS:
      return { ...state, distributeInProgress: false, distributeResult: payload };
    case DISTRIBUTE_ERROR:
      return { ...state, distributeInProgress: false, distributeError: payload };
    case DISTRIBUTE_RESET:
      return { ...state, distributeInProgress: false, distributeError: null, distributeResult: null };

    case FETCH_EMPLOYEES_REQUEST:
      return { ...state, fetchEmployeesInProgress: true, fetchEmployeesError: null };
    case FETCH_EMPLOYEES_SUCCESS:
      return { ...state, fetchEmployeesInProgress: false, employees: payload };
    case FETCH_EMPLOYEES_ERROR:
      return { ...state, fetchEmployeesInProgress: false, fetchEmployeesError: payload };

    case FETCH_VOUCHER_POOLS_REQUEST:
      return { ...state, fetchVoucherPoolsInProgress: true, fetchVoucherPoolsError: null };
    case FETCH_VOUCHER_POOLS_SUCCESS:
      return { ...state, fetchVoucherPoolsInProgress: false, voucherPools: payload };
    case FETCH_VOUCHER_POOLS_ERROR:
      return { ...state, fetchVoucherPoolsInProgress: false, fetchVoucherPoolsError: payload };

    case UPDATE_SETTINGS_REQUEST:
      return { ...state, updateSettingsInProgress: true, updateSettingsError: null, updateSettingsResult: null };
    case UPDATE_SETTINGS_SUCCESS:
      return { ...state, updateSettingsInProgress: false, updateSettingsResult: payload, company: state.company ? { ...state.company, ...payload } : payload };
    case UPDATE_SETTINGS_ERROR:
      return { ...state, updateSettingsInProgress: false, updateSettingsError: payload };

    default:
      return state;
  }
}

// ================ Thunks ================ //

// Fetch the company for the current user (lookup by admin role)
export const fetchMyCompany = () => dispatch => {
  dispatch({ type: FETCH_MY_COMPANY_REQUEST });
  return get('/api/companies/my')
    .then(response => {
      dispatch({ type: FETCH_MY_COMPANY_SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(e => {
      dispatch({ type: FETCH_MY_COMPANY_ERROR, payload: storableError(e) });
    });
};

export const fetchStats = slug => dispatch => {
  dispatch({ type: FETCH_STATS_REQUEST });
  return get(`/api/companies/${slug}/stats`)
    .then(response => {
      dispatch({ type: FETCH_STATS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_STATS_ERROR, payload: storableError(e) });
    });
};

export const fetchCompanyVouchers = slug => dispatch => {
  dispatch({ type: FETCH_VOUCHERS_REQUEST });
  return get(`/api/companies/${slug}/vouchers`)
    .then(response => {
      dispatch({ type: FETCH_VOUCHERS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_VOUCHERS_ERROR, payload: storableError(e) });
    });
};

export const fetchUsage = slug => dispatch => {
  dispatch({ type: FETCH_USAGE_REQUEST });
  return get(`/api/companies/${slug}/usage`)
    .then(response => {
      dispatch({ type: FETCH_USAGE_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_USAGE_ERROR, payload: storableError(e) });
    });
};

export const distributeCredits = (slug, data) => dispatch => {
  dispatch({ type: DISTRIBUTE_REQUEST });
  return post(`/api/companies/${slug}/distribute`, data)
    .then(response => {
      dispatch({ type: DISTRIBUTE_SUCCESS, payload: response.data });
      dispatch(fetchCompanyVouchers(slug));
      dispatch(fetchStats(slug));
      dispatch(fetchCompanyEmployees(slug));
      dispatch(fetchVoucherPools(slug));
      return response;
    })
    .catch(e => {
      dispatch({ type: DISTRIBUTE_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const resetDistribute = () => ({ type: DISTRIBUTE_RESET });

export const fetchVoucherPools = slug => dispatch => {
  dispatch({ type: FETCH_VOUCHER_POOLS_REQUEST });
  return get(`/api/companies/${slug}/voucher-pools`)
    .then(response => {
      dispatch({ type: FETCH_VOUCHER_POOLS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_VOUCHER_POOLS_ERROR, payload: storableError(e) });
    });
};

export const fetchCompanyEmployees = slug => dispatch => {
  dispatch({ type: FETCH_EMPLOYEES_REQUEST });
  return get(`/api/companies/${slug}/employees`)
    .then(response => {
      dispatch({ type: FETCH_EMPLOYEES_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: FETCH_EMPLOYEES_ERROR, payload: storableError(e) });
    });
};

export const resendEmployeeInvite = (slug, employeeId) => dispatch => {
  return post(`/api/companies/${slug}/employees/${employeeId}/resend`)
    .then(() => dispatch(fetchCompanyEmployees(slug)))
    .catch(e => { throw e; });
};

export const revokeEmployeeVoucher = (slug, employeeId) => dispatch => {
  return post(`/api/companies/${slug}/employees/${employeeId}/revoke`)
    .then(() => {
      dispatch(fetchCompanyEmployees(slug));
      dispatch(fetchCompanyVouchers(slug));
      dispatch(fetchStats(slug));
    })
    .catch(e => { throw e; });
};

export const exportCsv = slug => () => {
  window.open(`/api/companies/${slug}/export`, '_blank');
};

export const updateSettings = (slug, data) => dispatch => {
  dispatch({ type: UPDATE_SETTINGS_REQUEST });
  return patch(`/api/companies/${slug}/settings`, data)
    .then(response => {
      dispatch({ type: UPDATE_SETTINGS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      dispatch({ type: UPDATE_SETTINGS_ERROR, payload: storableError(e) });
      throw e;
    });
};

export const loadData = () => async dispatch => {
  await dispatch(fetchCurrentUser());
  const result = await dispatch(fetchMyCompany());
  if (result?.slug) {
    await Promise.all([
      dispatch(fetchStats(result.slug)),
      dispatch(fetchCompanyVouchers(result.slug)),
      dispatch(fetchUsage(result.slug)),
      dispatch(fetchCompanyEmployees(result.slug)),
      dispatch(fetchVoucherPools(result.slug)),
    ]);
  }
};
